export { DataProviderFilterType } from './data/schema/DataProviderFilterType';
export { UserDataServiceRequestType } from './data/schema/UserDataServiceRequestType';
export {
    UserProfile_InfoSource,
    SharePoint_InfoSource,
    OneDrive_InfoSource,
    Unknown_InfoSource,
} from './data/schema/constants';
export type { Suggestion } from './data/schema/UserDataServiceSchema';
export type { DataProviderFilter } from './data/schema/UserDataServiceSchema';

export { default as getSuggestionsFromUserDataService } from './services/getSuggestionsFromUserDataService';
